import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactECharts from "echarts-for-react";
import MainAnimation from "@components/MainAnimation";
import dashboardService from "../services/dashboardService";
import MensalYearGraph from "@components/Dashboard/MensalYearGraph";
import historicalData from "../utils/data/ICEStocksHistorical2.json";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Container,
  Typography,
  Box,
} from "@material-ui/core";
import { ImgCotacao } from "../components/Feed/CotacaoInfo";
import { green, grey } from "@material-ui/core/colors";
import { useSelector } from "react-redux";
import formatDate from "@utils/formatDate";
import WeatherAlerts from "../components/Dashboard/WeatherAlerts";
import IceStocksRobusta from "../components/Dashboard/IceStocksRobusta";
//import VariationTable from "../components/Dashboard/VariationTable";
import Contratos from "../components/Dashboard/Contratos";
import { Watermark } from "../components/Dashboard/Contratos";

function Dashboard() {
  let [iceReports, setIceReports] = useState([]);
  let [loading, setLoading] = useState();
  const [cotacao, theme] = useSelector((states) => [
    states.cotacaoReducer,
    states.authReducer.theme,
  ]);
  const location = useLocation();
  const isIceStocksArabica = location.pathname.includes("/icestocks_arabica");
  const isIceStocksRobusta = location.pathname.includes("/icestocks_robusta");
  const isContratos = location.pathname.includes("/contratos");
  const isWeatherReports = location.pathname.includes("/alertas");

  useEffect(() => {
    setLoading(true);
    dashboardService
      .getIceReports(1)
      .then((rIceReports) => {
        setIceReports(rIceReports);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => setLoading(false));
  }, []);

  let reversedReports = [...iceReports].reverse();
  let allReports = [...historicalData, ...reversedReports];
  return (
    <MainAnimation>
      <Container maxWidth="lg" style={{ paddingTop: 20, display: "flex" }}>
        <Paper style={{ width: "100%", padding: 24, minHeight: 300 }}>
          <Box sx={{ width: "100%", marginTop: 4 }}>
            {/* Aba 1 - Gráfico e ICE */}
            {isIceStocksArabica && (
              <Box mt={3}>
                {/* Tabela NY */}
                <TableContainer
                  component={Paper}
                  style={{ position: "relative" }}
                >
                  <Watermark />
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <div
                            style={{
                              display: "flex",
                              gap: 4,
                              alignItems: "center",
                            }}
                          >
                            <ImgCotacao />
                            ICE Stocks NY
                          </div>
                        </TableCell>
                        <TableCell style={{ textAlign: "right" }}>
                          Total Sacos
                        </TableCell>
                        <TableCell style={{ paddingLeft: 12 }}>%</TableCell>
                        <TableCell style={{ textAlign: "right" }}>
                          Pendentes
                        </TableCell>
                        <TableCell style={{ paddingLeft: 12 }}>%</TableCell>
                        <TableCell style={{ textAlign: "right" }}>
                          Aprovadas
                        </TableCell>
                        <TableCell style={{ paddingLeft: 12 }}>%</TableCell>
                        <TableCell style={{ textAlign: "right" }}>
                          Reprovadas
                        </TableCell>
                        <TableCell style={{ paddingLeft: 12 }}>%</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>Variação</TableCell>

                        <DifferenceCell
                          iceReports={iceReports}
                          keyName={"totalBagsCertified"}
                        />

                        <TableCell></TableCell>

                        <DifferenceCell
                          iceReports={iceReports}
                          keyName={"bagsPendingGrading"}
                        />

                        <TableCell></TableCell>

                        <TableCell></TableCell>

                        <TableCell></TableCell>

                        <TableCell></TableCell>

                        <TableCell></TableCell>
                      </TableRow>
                      {iceReports?.map((row, index) => {
                        const next = iceReports[index + 1];
                        const bagsChange = (key) =>
                          next
                            ? getPercentageChange(row[key], next[key])
                            : null;

                        const getColor = (val) => {
                          if (val == null) return undefined;
                          return parseFloat(val) < 0 ? "red" : green[500];
                        };

                        const getApprovedFailed = (r, key) => {
                          if (!r.bagsFailedGrading || !r.bagsPassedGrading)
                            return null;
                          return (
                            (r[key] /
                              (r.bagsFailedGrading + r.bagsPassedGrading)) *
                            100
                          ).toFixed(2);
                        };

                        return (
                          <TableRow key={row._id}>
                            <TableCell>
                              {new Date(row.createdAt).toLocaleString("pt-BR", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              })}
                            </TableCell>
                            <TableCell style={{ textAlign: "right" }}>
                              {row.totalBagsCertified?.toLocaleString() ?? "—"}
                            </TableCell>
                            <TableCell
                              style={{
                                color: getColor(
                                  bagsChange("totalBagsCertified"),
                                ),
                                paddingLeft: 12,
                              }}
                            >
                              {bagsChange("totalBagsCertified") != null
                                ? `${bagsChange("totalBagsCertified")}%`
                                : "—"}
                            </TableCell>
                            <TableCell style={{ textAlign: "right" }}>
                              {row.bagsPendingGrading?.toLocaleString() ?? "—"}
                            </TableCell>
                            <TableCell
                              style={{
                                color: getColor(
                                  bagsChange("bagsPendingGrading"),
                                ),
                                paddingLeft: 12,
                              }}
                            >
                              {bagsChange("bagsPendingGrading") != null
                                ? `${bagsChange("bagsPendingGrading")}%`
                                : "—"}
                            </TableCell>
                            <TableCell style={{ textAlign: "right" }}>
                              {row.bagsPassedGrading?.toLocaleString() ?? "—"}
                            </TableCell>
                            <TableCell style={{ paddingLeft: 12 }}>
                              {!!getApprovedFailed(row, "bagsPassedGrading")
                                ? `${getApprovedFailed(row, "bagsPassedGrading")}%`
                                : "—"}
                            </TableCell>
                            <TableCell style={{ textAlign: "right" }}>
                              {row.bagsFailedGrading?.toLocaleString() ?? "—"}
                            </TableCell>
                            <TableCell style={{ paddingLeft: 12 }}>
                              {!!getApprovedFailed(row, "bagsFailedGrading")
                                ? `${getApprovedFailed(row, "bagsFailedGrading")}%`
                                : "—"}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Tabela Londres */}

                {/* Gráfico */}
                <Box mt={5}>
                  <EChartsGradingChart
                    data={[...historicalData, ...reversedReports]}
                  />
                </Box>
                <MensalYearGraph data={allReports} />
                <VariationTable iceReports={allReports} />
              </Box>
            )}
            {isIceStocksRobusta && <IceStocksRobusta iceReports={iceReports} />}
            {/* Aba 2 - Vencimentos */}
            {isContratos && <Contratos />}
          </Box>

          {isWeatherReports && <WeatherAlerts />}
        </Paper>
      </Container>
    </MainAnimation>
  );
}

export default Dashboard;

// Funções auxiliares
export const getPercentageChange = (current, previous) => {
  if (previous == null || previous === 0) return null;
  return (((current - previous) / previous) * 100).toFixed(2);
};

export const DifferenceCell = ({ iceReports, keyName, daysAgo = 1 }) => {
  if (!iceReports?.length) return <TableCell>-</TableCell>;

  const sortedReports = [...iceReports].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
  );

  // Get the most recent report that has a valid keyName value
  const latest = sortedReports.find((report) => report?.[keyName] != null);
  if (!latest) return <TableCell>-</TableCell>;

  const targetDate = new Date(latest.createdAt);
  targetDate.setDate(targetDate.getDate() - daysAgo);
  //console.log("targetDate", targetDate);
  // Find the closest report to the target date (excluding the `latest` report)
  const closestReport = sortedReports.reduce((closest, current) => {
    if (current._id === latest._id || current?.[keyName] == null)
      return closest;

    const currentDiff = Math.abs(new Date(current.createdAt) - targetDate);
    const closestDiff = closest
      ? Math.abs(new Date(closest.createdAt) - targetDate)
      : Infinity;

    return currentDiff < closestDiff ? current : closest;
  }, null);

  const latestValue = latest?.[keyName] ?? 0;
  const pastValue = closestReport?.[keyName] ?? 0;
  const diff = latestValue - pastValue;

  const getColor = () => {
    if (diff > 0) return green[500];
    if (diff < 0) return "red";
    return "inherit";
  };

  const getPrefix = () => {
    if (diff > 0) return "+";
    if (diff < 0) return "-";
    return "";
  };

  return (
    <TableCell style={{ color: getColor(), fontWeight: "bold" }} align="right">
      {getPrefix()}
      {Math.abs(diff).toLocaleString()}
    </TableCell>
  );
};
function EChartsGradingChart({ data }) {
  const formattedDates = data?.map((item) => {
    const d = new Date(item.createdAt);
    return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
  });

  const BLUE = "#6ecaff";
  const GRAY = grey[400];

  const option = {
    title: {
      text: `Total Sacos x Preco NY (cts/lb)`,
      left: "center",
      textStyle: { color: GRAY },
    },
    tooltip: { trigger: "axis" },
    legend: {
      top: 30,
      data: ["Certificados", "Preço NY"],
      textStyle: {
        color: GRAY,
      },
    },
    xAxis: { type: "category", data: formattedDates },
    yAxis: [
      {
        type: "value",
        name: "Total Sacos Certificados",
        position: "left",
        axisLine: { lineStyle: { color: BLUE } },
        axisLabel: { formatter: "{value}" },
        alignTicks: true, // <-- Add this
      },
      {
        type: "value",
        name: "Preço NY",
        position: "right",
        axisLine: { lineStyle: { color: GRAY } },
        axisLabel: { formatter: "{value}" },
        alignTicks: true, // <-- And this
      },
    ],
    series: [
      {
        name: "Certificados",
        type: "line",
        data: data.map((d) =>
          d.totalBagsCertified === 0 ? null : d.totalBagsCertified,
        ),
        color: BLUE,
        connectNulls: true,
        yAxisIndex: 0,
      },
      {
        name: "Preço NY",
        type: "line",
        data: data.map((d) => (d.priceArabica === 0 ? null : d.priceArabica)),
        color: GRAY,
        connectNulls: true,
        yAxisIndex: 1,
      },
    ],
    grid: { left: "10%", right: "10%", bottom: "15%" },
    toolbox: { feature: { saveAsImage: {}, dataZoom: {}, restore: {} } },
    dataZoom: [{ type: "slider", start: 0, end: 100 }],

    graphic: {
      elements: [
        {
          type: "text",
          left: "center",
          top: "center",
          style: {
            text: "cafetrade.com.br",
            fontSize: 30,
            fontWeight: "bold",
            fill: "rgba(200, 200, 200, 0.3)",
          },
          z: -10, // Send to back
        },
      ],
    },
  };

  return (
    <ReactECharts option={option} style={{ height: "500px", width: "100%" }} />
  );
}
let intervals = [1, 7];
const VariationTable = ({ iceReports }) => {
  return (
    <TableContainer component={Paper} style={{ maxWidth: 600 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Intervalo</TableCell>
            <TableCell align="right">Total Sacos</TableCell>
            <TableCell />
            <TableCell align="right">Pendentes </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {intervals.map((daysAgo) => (
            <TableRow key={`variation-${daysAgo}`}>
              <TableCell component="th" scope="row">
                Variação {daysAgo} dia{daysAgo === 1 ? `` : `s`}
              </TableCell>

              <DifferenceCell
                iceReports={iceReports}
                keyName="totalBagsCertified"
                daysAgo={daysAgo}
              />

              <TableCell align="center">→</TableCell>

              <DifferenceCell
                iceReports={iceReports}
                keyName="bagsPendingGrading"
                daysAgo={daysAgo}
              />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
